import React, { useEffect } from 'react';

function EmailSystem() {
	return (
		<>
			<table className="body">
				<tbody>
					<tr>
						<td className="center" align="center" valign="top">
							<center>
								<table className="row header">
									<tbody>
										<tr>
											<td className="center" align="center">
												<center>
													<table className="container">
														<tbody>
															<tr>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td>
																					<a href="/dashboard/v4">
																						<img
																							src="/color-admin/admin/react/assets/img/logo/logo-admin.png"
																							height="24px"
																							alt="Color Admin logo"
																						/>
																					</a>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td className="text-end valign-middle">
																					<span
																						style={{
																							lineHeight: '24px',
																							display: 'block'
																						}}
																					>
																						Verification Email
																					</span>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
															</tr>
														</tbody>
													</table>
												</center>
											</td>
										</tr>
									</tbody>
								</table>
								<table
									className="container content light-theme email-shell"
									width="580"
									style={{ width: '580px', background: '#ffffff' }}
									cellPadding="0"
									cellSpacing="0"
								>
									<tbody>
										<tr>
											<td>
												<table className="row">
													<tbody>
														<tr>
															<td
																className="hero-panel"
																style={{ background: '#2d353c', padding: '30px' }}
															>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td className="last">
																				<p
																					className="eyebrow"
																					style={{
																						fontSize: '10px',
																						fontWeight: 'bold',
																						letterSpacing: '1.5px',
																						textTransform: 'uppercase',
																						margin: '0 0 15px'
																					}}
																				>
																					Account verification
																				</p>
																				<h1
																					style={{
																						color: '#ffffff',
																						fontSize: '28px',
																						lineHeight: '32px',
																						fontWeight: 'bold',
																						margin: '0 0 10px'
																					}}
																				>
																					Verify your WrapMarket account
																				</h1>
																				<p
																					className="hero-copy"
																					style={{
																						color: '#d1d5db',
																						fontSize: '15px',
																						lineHeight: '22px',
																						margin: '0 0 22px'
																					}}
																				>
																					Thanks for joining WrapMarket.
																					Confirm your email address to secure
																					your account and start exploring
																					marketplace-ready templates,
																					dashboards, and UI kits.
																				</p>
																				<table
																					className="btn blue"
																					align="left"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									background:
																										'#0F83F0',
																									padding:
																										'10px 20px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#ffffff',
																										fontSize:
																											'13px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									Verify Email Address
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<p
																					style={{
																						color: '#6b7280',
																						fontSize: '12px',
																						lineHeight: '18px',
																						margin: '15px 0 0'
																					}}
																				>
																					<i>
																						This is a system-generated
																						email. Please do not reply to
																						this message.
																					</i>
																				</p>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
												<table className="row">
													<tbody>
														<tr>
															<td
																className="email-section"
																style={{ padding: '24px 30px 10px' }}
															>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td>
																				<p
																					className="eyebrow"
																					style={{
																						fontSize: '10px',
																						fontWeight: 'bold',
																						letterSpacing: '1.5px',
																						textTransform: 'uppercase',
																						margin: '0 0 15px'
																					}}
																				>
																					HANDPICKED FOR YOU
																				</p>
																				<h4
																					style={{
																						color: '#2d353c',
																						fontSize: '20px',
																						lineHeight: '26px',
																						fontWeight: 'bold',
																						margin: '0 0 5px'
																					}}
																				>
																					Build faster with WrapMarket
																				</h4>
																				<p
																					style={{
																		color: '#4b5563',
																						fontSize: '13px',
																						lineHeight: '20px',
																						margin: '0 0 15px'
																					}}
																				>
																					{' '}
																					Explore production-ready templates,
																					reusable components, responsive
																					layouts, and polished starter pages
																					from trusted creators, all designed
																					to help you launch your next project
																					with less setup work.{' '}
																				</p>
																				<p style={{ margin: '0 0 15px' }}>
																					<a href="/dashboard/v1">
																						<img
																							src="/color-admin/admin/react/assets/img/mailbox/img-3.png"
																							alt="WrapMarket template preview"
																							style={{
																								border: '0',
																								display: 'block',
																								margin: '0 0 15px'
																							}}
																						/>
																					</a>
																				</p>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<table
																					width="100%"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								width="134"
																								style={{
																									width: '134px',
																									padding: '0 15px'
																								}}
																							>
																								<table
																									width="100%"
																									cellPadding="0"
																									cellSpacing="0"
																								>
																									<tbody>
																										<tr>
																											<td
																												style={{
																													color: '#2d353c',
																													fontSize:
																														'22px',
																													lineHeight:
																														'28px',
																													fontWeight:
																														'bold',
																													textAlign:
																														'center'
																												}}
																											>
																												100+
																											</td>
																										</tr>
																										<tr>
																											<td
																												style={{
																													color: '#6b7280',
																													fontSize:
																														'12px',
																													lineHeight:
																														'18px',
																													textAlign:
																														'center'
																												}}
																											>
																												Ready
																												pages
																											</td>
																										</tr>
																									</tbody>
																								</table>
																							</td>
																							<td
																								width="10"
																								style={{
																									width: '10px',
																									fontSize: '1px',
																									lineHeight: '1px'
																								}}
																							></td>
																							<td
																								width="134"
																								style={{
																									width: '134px',
																									padding: '0 15px'
																								}}
																							>
																								<table
																									width="100%"
																									cellPadding="0"
																									cellSpacing="0"
																								>
																									<tbody>
																										<tr>
																											<td
																												style={{
																													color: '#2d353c',
																													fontSize:
																														'22px',
																													lineHeight:
																														'28px',
																													fontWeight:
																														'bold',
																													textAlign:
																														'center'
																												}}
																											>
																												50+
																											</td>
																										</tr>
																										<tr>
																											<td
																												style={{
																													color: '#6b7280',
																													fontSize:
																														'12px',
																													lineHeight:
																														'18px',
																													textAlign:
																														'center'
																												}}
																											>
																												Theme
																												styles
																											</td>
																										</tr>
																									</tbody>
																								</table>
																							</td>
																							<td
																								width="10"
																								style={{
																									width: '10px',
																									fontSize: '1px',
																									lineHeight: '1px'
																								}}
																							></td>
																							<td
																								width="134"
																								style={{
																									width: '134px',
																									padding: '0 15px'
																								}}
																							>
																								<table
																									width="100%"
																									cellPadding="0"
																									cellSpacing="0"
																								>
																									<tbody>
																										<tr>
																											<td
																												style={{
																													color: '#2d353c',
																													fontSize:
																														'22px',
																													lineHeight:
																														'28px',
																													fontWeight:
																														'bold',
																													textAlign:
																														'center'
																												}}
																											>
																												99+
																											</td>
																										</tr>
																										<tr>
																											<td
																												style={{
																													color: '#6b7280',
																													fontSize:
																														'12px',
																													lineHeight:
																														'18px',
																													textAlign:
																														'center'
																												}}
																											>
																												Flexible
																												toolkit
																											</td>
																										</tr>
																									</tbody>
																								</table>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
												<table className="divider"></table>
											</td>
										</tr>
									</tbody>
								</table>
								<table className="row footer">
									<tbody>
										<tr>
											<td className="center" align="center">
												<center>
													<table className="container">
														<tbody>
															<tr>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td> © SeanTheme 2026. </td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td className="wrapper text-end valign-middle">
																					<a
																						href="#/"
																						style={{ color: '#333333' }}
																					>
																						About Us
																					</a>
																					<a
																						href="#/"
																						style={{ color: '#333333' }}
																					>
																						Privacy Policy
																					</a>
																					<a
																						href="#/"
																						style={{ color: '#333333' }}
																					>
																						Terms of Use
																					</a>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
															</tr>
														</tbody>
													</table>
												</center>
											</td>
										</tr>
									</tbody>
								</table>
							</center>
						</td>
					</tr>
				</tbody>
			</table>
		</>
	);
}

function EmailSystemPage() {
	useEffect(() => {
		document.body.classList.add('email-page');
		return () => document.body.classList.remove('email-page');
	}, []);

	return (
		<div className="email-template-page">
			<EmailSystem />
		</div>
	);
}

export default EmailSystemPage;
